import React from 'react';
import { PieChart } from '../../../../ui-components/data-viz-ui/charts/pie-chart/PieChart';
import { TimePeriodUnsegmentedPieChartUiComponentProps } from './types';

export const TimePeriodUnsegmentedPieChartUiComponent = (
  props: TimePeriodUnsegmentedPieChartUiComponentProps
) => {
  return <PieChart {...props} />;
};
